export default "__VITE_ASSET__CDfWliQx__"